import { useMemo } from "react";
import { useDashboard } from "./useDashboard";

/**
 * Usa snapshot estático (apresentação pública) ou busca dados via useDashboard.
 */
export function useDashboardWithPresentation(scope, subpath, params, options = {}, presentationSnapshot) {
  const { select, ...queryOptions } = options;
  const enabled = !presentationSnapshot;

  const query = useDashboard(scope, subpath, params, {
    ...queryOptions,
    select,
    enabled: enabled && queryOptions.enabled !== false,
  });

  return useMemo(() => {
    if (!presentationSnapshot) return query;

    let data = presentationSnapshot;
    if (typeof select === "function") {
      try {
        data = select(presentationSnapshot);
      } catch {
        data = presentationSnapshot;
      }
    }

    return {
      ...query,
      data,
      isLoading: false,
      isFetching: false,
      isDeferred: false,
      isComputing: false,
      isPreview: false,
      isFetchingFull: false,
      error: null,
    };
  }, [presentationSnapshot, query, select]);
}
